import getLpuAvatarUrl, {
  LPU_NO_AVATAR_URL,
  getLpuLogoLastFileUrl,
} from 'src/utils/getLpuAvatarUrl'

const lpuWithLegacy = {
  cropped_logo: 'logos/cropped.png',
  img_50: { url: '/media/img50.png' },
  img_100: { url: '/media/img100.png' },
  img_200: { url: '/media/img200.png' },
}

const lpuWithPriority = {
  logo: {
    priority_image_files: [
      {
        file: { url: '/media/logo.avif' },
        file_format: 'avif',
      },
      {
        file: { url: '/media/logo.webp' },
        file_format: 'webp',
      },
      {
        file: { url: '/media/logo.png' },
        file_format: 'png',
      },
    ],
  },
}

describe('getLpuAvatarUrl', () => {
  test('Передан ff_update_lpu_logo — Тогда берётся URL последнего priority-файла', () => {
    expect(getLpuAvatarUrl({
      lpu: lpuWithPriority,
      ff_update_lpu_logo: true,
    })).toBe('/media/logo.png')
  })

  test('Передан ff_update_lpu_logo без файлов — Тогда заглушка без /media префикса', () => {
    expect(getLpuAvatarUrl({
      lpu: {},
      ff_update_lpu_logo: true,
    })).toBe(LPU_NO_AVATAR_URL)
  })

  test('Флаг выключен — Тогда остаётся старая цепочка cropped_logo', () => {
    expect(getLpuAvatarUrl({ lpu: lpuWithLegacy })).toBe('/media/logos/cropped.png')
  })
})

describe('getLpuLogoLastFileUrl', () => {
  test('Передан список файлов — Тогда URL последнего', () => {
    expect(getLpuLogoLastFileUrl(lpuWithPriority)).toBe('/media/logo.png')
  })
})
